import { EncryptionService } from '../../general/encryption-service';
import { environment } from 'src/environments/environment';
import { eSimApiPaths } from 'src/app/core/consts';
import { ExceptionsService } from '../../general/exceptions-service';
import { forkJoin, Observable, of, switchMap } from 'rxjs';
import { HttpClientService } from '../../general/http-client-service';
import { Injectable } from '@angular/core';
import { PartnerClientLinkAddDTOe, PartnerClientLinkDTOe } from 'src/app/core/models/system/partners/partner-client-link.dto';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';

@Injectable({ providedIn: 'root' })

export class PartnerClientLinksService {

  constructor(
    private encryptionService: EncryptionService,
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public add(partnerCompanyId: number, clientCompanyId: number, link: PartnerClientLinkAddDTOe): Observable<PartnerClientLinkDTOe> {
    try {
      return forkJoin([this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>partnerCompanyId, true),
                       this.encryptionService.encrypt_AesServerSideForWeb(<string><unknown>clientCompanyId,  true)])
             .pipe(
                switchMap(([encPartner, encClient]: StringResultDTO[]) => {
                            link.partnerCompanyIdEncSS=encPartner.result;
                            link.clientCompanyIdEncSS =encClient.result;

                            return this.encryptionService.encrypt_AesServerSideForWeb(JSON.stringify(link))
                                   .pipe(
                                      switchMap((encResult: StringResultDTO) => {
                                                  return <Observable<PartnerClientLinkDTOe>>this.httpClientService.post(
                                                    environment.eSimApi
                                                    + eSimApiPaths.PartnerClientLinks,
                                                    { objectEncSS: encResult.result });
                                               })
                                   );
                         })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public end(idEncSS: string): Observable<any> {
    try {
      return this.httpClientService.put(environment.eSimApi
                                        + eSimApiPaths.PartnerClientLinks
                                        + "/"
                                        + eSimApiPaths.PartnerClientLinksEnd
                                        + "?idEncSS=" + idEncSS,
                                        undefined,
                                        {});
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getAll(): Observable<PartnerClientLinkDTOe[]> {
    try {
      return this.httpClientService.get<PartnerClientLinkDTOe[]>(environment.eSimApi + eSimApiPaths.PartnerClientLinks);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of([]);
    }
  }
}
